import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import LogoVoice from '../../assets/images/logo-voice.svg';
import { landingUrl } from '../../../globals';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    display: 'inline-flex',
    gridGap: theme.spacing(2),
    marginBottom: theme.margin.bottom,
    '& img': {
      maxHeight: '42px',
    },
  },
  [theme.breakpoints.up('sm')]: {
    root: {
      '& img': {
        maxHeight: '50px',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    root: {
      '& img': {
        maxHeight: '70px',
      },
    },
  },
}));

const VoiceLogo = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <a
      href={landingUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.root}
    >
      <img
        src={LogoVoice}
        alt={t('voice_logo_alt')}
      />
    </a>
  );
};

export default VoiceLogo;
